import React from 'react'
import { Link } from '~components'
import styled from 'styled-components/macro'
import { Box } from '~styled'

export const HeaderButtonWrapper = styled(Box)`
    .btn{
        min-width:auto;
        height: 42px;
        border-radius: 5px;
        font-size: 15px;
        font-weight: 500;
        line-height: 28px;
        display:flex;
        align-items:center;
        justify-content:center;
        padding-left:15px;
        padding-right:15px;
        letter-spacing: -0.4px;
        margin-left:10px;
        color:#262729;
        &-2{
            border-radius:55px;
            color:#fff;
            min-width: 194px;
            font-weight: 400;
            height: 42px;
            background-color: #0052cc;
            border-color: #0052cc;
            height: 42px;
            &:hover{
                box-shadow: 0 0px 0px rgba(241, 139, 98, 0.3);
            }
        }
    }
`
const HeaderButton = ({btnOneLink,btnTwoLink,btnOneText,btnTwoText,...rest})=>{
    return(
        <HeaderButtonWrapper {...rest}>
            <Link className="btn btn-1" to="https://account.docpile.io">
                {btnOneText}
            </Link>
            <Link className="btn btn-2" to="/early-access">
                {btnTwoText}
            </Link>
        </HeaderButtonWrapper>
    )
}

export default HeaderButton;